export const revisionButtonTooltips = {
  missingPermissions:
    "You do not have the permissions required to perform this operation.",
  missingRequiredInformation: "Missing required information: ",
  requiredPermissionsTextToSign:
    "Mandatory Fields Missing. Please complete remaining required (flagged with astericks)* questions to sign.",
  requiredPermissionsTextToSignAndLock:
    "Mandatory Fields Missing. Please complete remaining required (flagged with astericks)* questions to sign and lock."
};
